/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Local_DeliveryInputs */

const en_fulfillment_local_delivery = /** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Delivery`)
};

const id_fulfillment_local_delivery = /** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengiriman Lokal`)
};

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const es_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const fr_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const de_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const ja_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const zh_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const ar_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const it_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const ru_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const pt_fulfillment_local_delivery = en_fulfillment_local_delivery;

/** @type {(inputs: Fulfillment_Local_DeliveryInputs) => LocalizedString} */
const ko_fulfillment_local_delivery = en_fulfillment_local_delivery;

/**
* | output |
* | --- |
* | "Local Delivery" |
*
* @param {Fulfillment_Local_DeliveryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_local_delivery = /** @type {((inputs?: Fulfillment_Local_DeliveryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Local_DeliveryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_local_delivery(inputs)
	if (locale === "es") return es_fulfillment_local_delivery(inputs)
	if (locale === "fr") return fr_fulfillment_local_delivery(inputs)
	if (locale === "de") return de_fulfillment_local_delivery(inputs)
	if (locale === "ja") return ja_fulfillment_local_delivery(inputs)
	if (locale === "zh") return zh_fulfillment_local_delivery(inputs)
	if (locale === "ar") return ar_fulfillment_local_delivery(inputs)
	if (locale === "id") return id_fulfillment_local_delivery(inputs)
	if (locale === "it") return it_fulfillment_local_delivery(inputs)
	if (locale === "ru") return ru_fulfillment_local_delivery(inputs)
	if (locale === "pt") return pt_fulfillment_local_delivery(inputs)
	return ko_fulfillment_local_delivery(inputs)
});